export const copyAndSort = (items, columnKey, isSortedDescending) => {
    const key = columnKey;
    return items.slice(0).sort((a, b) => {
        const one = a[key] ? a[key] : '0';
        const two = b[key] ? b[key] : '0';
        return (isSortedDescending ? one < two : one > two) ? 1 : -1;
    });
};
